// extracted by mini-css-extract-plugin
export default {"wrapper":"Passing_wrapper__L00EI","title":"Passing_title__5XM8s","typePost":"Passing_typePost__ZdELQ"};